import React from "react"
import * as style from "./style.module.scss"
import { render } from "storyblok-rich-text-react-renderer"

function checkFileType(filename: any) {
  const extension = filename.split(".").pop().toLowerCase()

  const videoExtensions = ["mp4", "avi", "mov", "mkv"]

  if (videoExtensions.includes(extension)) {
    return "video"
  }
  return "image"
}

function LeftRightHighlights(props: any) {
  return (
    <div className="overflow-hidden w-full">
      <div
        className={`${style.leftRightBackg} feature-block max-w-full m-auto`}
      >
        <div
          className={`flex items-center flex-col ${
            props.reverse ? "lg:flex-row-reverse" : "lg:flex-row"
          }`}
        >
          <div className="py-28 lg:py-0 px-5 lg:px-0 w-full flex lg:w-1/3 flex-col items-left justify-center bg-cover lg:h-auto lg:bg-none">
            <p className="font-black  lg:leading-[1.1rem] text-2xl lg:text-sm xl:text-xl 2xl:text-4xl px-[2vw] text-left lg:text-left text-white mb-2 lg:md-8">
              {props.title}
            </p>
            <p className="hidden xl:block text-left lg:text-md lg:text-left px-[2vw] text-white">
              {props.description ? render(props.description) : ""}
            </p>
            <p className="block xl:hidden text-left lg:text-xs lg:text-left px-[2vw] text-white m-0">
              {props.description ? render(props.description) : ""}
            </p>
          </div>
          <div className="w-full lg:w-2/3">
            {checkFileType(props.media.filename) === "video" ? (
              <video
                autoPlay={true}
                muted={true}
                loop={true}
                playsInline={true}
                className="block w-full"
              >
                <source src={props.media.filename} />
              </video>
            ) : (
              <>
                <img
                  className="w-full m-0 hidden lg:block"
                  src={props.media.filename}
                  alt="lensProduct"
                />
                <img
                  className="w-full m-0 block lg:hidden"
                  src={props.media.filename}
                  alt="lensProduct"
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default LeftRightHighlights
